import {GwgAccelerator} from '@udemy/career-academies';
import {GrowWithGoogleBannerPlanStats} from '@udemy/subscription-browse';

export const PRACTICE_ACTIVITIES_COUNT = 20;

export const computePlanStats = (
    allGwgAccelerators?: GwgAccelerator[],
): GrowWithGoogleBannerPlanStats => {
    const accelerators = allGwgAccelerators ?? [];

    return {
        pathCount: accelerators.length,
        labsCount: PRACTICE_ACTIVITIES_COUNT,
    };
};
